import { PageContent, PageHeader } from '@/components';
import type { FC, PropsWithChildren, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  headerButtons?: ReactNode;
};

const WorkflowLayout: FC<PropsWithChildren<Props>> = ({
  children,
  headerButtons,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <PageHeader
        title={t('workflow')}
        breadcrumbs={[{ title: t('workflow') }]}
        buttons={headerButtons}
      />
      <PageContent>{children}</PageContent>
    </>
  );
};

export default WorkflowLayout;
